import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import i18n from './plugins/i18n'

import Home from '@/views/Home'
import Upcoming from '@/views/Upcoming'
import Competition from '@/views/Competition'
import Follow from '@/views/Follow'
import Facilities from '@/views/Facilities'
import Match from '@/views/Match'
import Team from '@/views/Team'
import Teams from '@/views/Teams'
import Live from '@/views/Live'
import Calendar from '@/views/Calendar'
import Sanctions from '@/views/Sanctions'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: loadLang
    },
    {
      path: '/upcoming',
      name: 'upcoming',
      component: Upcoming,
      beforeEnter: loadLang
    },
    {
      path: '/live',
      name: 'live',
      component: Live,
      beforeEnter: loadLang
    },
    {
      path: '/teams',
      name: 'teams',
      component: Teams,
      beforeEnter: loadLang
    },
    {
      path: '/match/:id',
      name: 'match',
      component: Match,
      beforeEnter: loadLang
    },
    {
      path: '/team/:id',
      name: 'team',
      component: Team,
      beforeEnter: loadLang
    },
    {
      path: '/competition',
      name: 'competition',
      component: Competition,
      beforeEnter: loadLang
    },
    {
      path: '/competition/:id',
      name: 'competition_category',
      component: Competition,
      beforeEnter: loadLang
    },
    {
      path: '/competition/:id/results',
      name: 'competition_category_results',
      component: Competition,
      beforeEnter: loadLang
    },
    {
      path: '/competition/:id/scoreboard',
      name: 'competition_category_scoreboard',
      component: Competition,
      beforeEnter: loadLang
    },
    {
      path: '/competition/:id/playoff',
      name: 'competition_category_playoff',
      component: Competition,
      beforeEnter: loadLang
    },
    {
      path: '/competition/:id/ranking',
      name: 'competition_category_ranking',
      component: Competition,
      beforeEnter: loadLang
    },
    {
      path: '/follow',
      name: 'follow',
      component: Follow,
      beforeEnter: loadLang
    },
    {
      path: '/facilities',
      name: 'facilities',
      component: Facilities,
      beforeEnter: loadLang
    },
    {
      path: '/facilities/:id',
      name: 'facilities_detail',
      component: Facilities,
      beforeEnter: loadLang
    },
    {
      path: '/sanctions',
      name: 'sanctions',
      component: Sanctions,
      beforeEnter: loadLang
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
      beforeEnter: loadLang,
      props: {
        type: 1
      }
    },
    {
      path: '/calendar/:category',
      name: 'calendar_category',
      component: Calendar,
      beforeEnter: loadLang,
      props: {
        type: 1
      }
    },
    {
      path: '/calendar/:category/:group',
      name: 'calendar_group',
      component: Calendar,
      beforeEnter: loadLang,
      props: { type: 1 }
    },
    {
      path: '/standing',
      name: 'standing',
      component: Calendar,
      beforeEnter: loadLang,
      props: { type: 0 }
    },
    {
      path: '/standing/:category',
      name: 'standing_category',
      component: Calendar,
      beforeEnter: loadLang,
      props: {
        type: 0
      }
    },
    {
      path: '/standing/:category/:group',
      name: 'standing_group',
      component: Calendar,
      beforeEnter: loadLang,
      props: {
        type: 0
      }
    },
    {
      path: '/event/:idEvent/facilities/lang/:lang',
      name: 'facilities',
      component: Facilities,
      beforeEnter: loadLang,
      meta: {
        layout: 'public'
      }
    },
    {
      path: '/event/:idEvent/facilities/:id/lang/:lang',
      name: 'facility',
      beforeEnter: loadLang,
      component: Facilities,
      meta: {
        layout: 'public'
      }
    },
    {
      path: '*',
      beforeEnter: redirectHome
    }
  ]
})

/*
    This will cehck to see if the user is authenticated or not.
*/
function requireAuth (to, from, next) {
  // console.log( "requireAuth User state: " + store.getters['user/getUserLoadStatus']() );
  // console.log( store );
  /*
      Determines where we should send the user.
    */
  function proceed () {
    /*
          If the user has been loaded determine where we should
          send the user.
        */
    if (store.getters['user/getUserLoadStatus']() == 2) {
      /*
              If the user is not empty, that means there's a user
              authenticated we allow them to continue. Otherwise, we
              send the user back to the home page.
            */
      var oSession = store.getters['user/getSession']
      if (moment(oSession.exp * 1000).valueOf() > moment().valueOf()) {
        next('/')
      } else {
        store.dispatch('logout').then(function () {
          next({ name: 'login' })
        })
      }
    }
  }

  /*
      Confirms the user has been loaded
    */
  if (store.getters['user/getUserLoadStatus']() != 2) {
    /*
          If not, load the user
        */
    store.dispatch('loadUser').then(function () {
      if (store.getters['user/getUserLoadStatus']() == 2) {
      } else {
        store.dispatch('logout').then(function () {
          next({ name: 'login' })
        })
      }
    })
  } else {
    /*
          User call completed, so we proceed
        */
    proceed()
  }
}

function redirectHome (to, from, next) {
  next('/')
}

function loadLang (to, from, next) {
  var lang = window.navigator.userLanguage || window.navigator.language
  lang = lang.substr(0, 2)
  if (!['en', 'es', 'ca'].includes(lang)) {
    lang = 'en'
  }

  i18n.loadLanguageAsync(lang).then(function () {
    next()
  })
}
